import { Button, Text, Box, Input } from "@chakra-ui/react"
import WithAuth from "../components/hoc/with-auth"
import { AuthLayout } from "../components/layouts/index"
import { LayoutWithSidebar } from "../components/layouts/layout-with-sidebar.tsx/index"
import DealsPage from "../components/pages/deals-page/index"
import OpenPositionsPage from "../components/pages/open-positions"
import TradesByIPPage from "../components/pages/trades-by-ip-page"

const TradesByIP = () => {
  return (
    <>
      <WithAuth>
        <LayoutWithSidebar
          pageTitle="Trades by IP Address"
          pageDesc="List of all the Trades by IP Address from 9th Jan 2024"
        >
          <TradesByIPPage />
        </LayoutWithSidebar>
      </WithAuth>
    </>
  )
}

export default TradesByIP
